export default form => {
    if (form && window.smartCaptcha) {
        let captcha = form.querySelector('.smart-captcha')

        if (captcha) {
            window.smartCaptcha.render(captcha, { sitekey: captcha.dataset.key })
        }
    }
}